var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconUpload = function SvgIconUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 64,
    "data-name": "Component 15 \\u2013 1",
    viewBox: "0 0 50 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e2e2ee",
    d: "M49.962 19.114v-.005a2 2 0 0 0-.172-.484 2 2 0 0 0-.062-.116 2 2 0 0 0-.313-.423l-17.5-17.5a2 2 0 0 0-.423-.313 2 2 0 0 0-.116-.062 2 2 0 0 0-.483-.172h-.01A2 2 0 0 0 30.5 0H4a4 4 0 0 0-4 4v56a4 4 0 0 0 4 4h22a2 2 0 0 0 0-4H4V4h24.5v13.5a4 4 0 0 0 4 4H46V34a2 2 0 0 0 4 0V19.5a2 2 0 0 0-.038-.386M32.5 17.5V6.829L43.172 17.5Zm16.914 27.584a2 2 0 1 1-2.828 2.828L40.5 41.828V62a2 2 0 0 1-4 0V41.828l-5.586 5.586a2 2 0 0 1-2.828-2.828l9-9a2 2 0 0 1 .306-.25 2 2 0 0 1 .156-.085 2 2 0 0 1 .188-.1 2 2 0 0 1 .205-.064c.056-.016.11-.038.168-.05a2 2 0 0 1 .784 0c.058.012.112.034.168.05a2 2 0 0 1 .205.064 2 2 0 0 1 .187.1c.052.029.107.052.157.086a2 2 0 0 1 .306.25Z",
    "data-name": "Path 75"
  })));
};
export default SvgIconUpload;